module.exports = __webpack_public_path__ + "0846f86ef6c102ccae38202233181418.svg";